import Contact from "../base/contact";
import { computed, field, print } from "@/utils/models/decorator-field";
import { printLocalDate } from "@/utils/pretty-print";
import {ignoredFields, model} from "@/utils/models/decorator-model";
import { DossierService } from "@/services/dossier-service";
import ProjectExtraFields from "@/models/base/project-extra-fields";
import { ProjectAwsDocument } from "./project-aws-document";
@model("Project")
@ignoredFields(["FriendlyID", "Contact.MainAddress.Contact"])

export default class Project {

	@field("number")
	public ID: number = 0;

	@field("string")
	public ComputedFriendlyID: string = "";

	@field("number")
	public ContactID: number = 0;

	@field("has-one", "Contact")
	public Contact: Contact | null = null;


	@field("string")
	public Description: string = "";

	@field("date")
	@print(printLocalDate)
	public TimeStamp: Date = new Date();


	@field("number")
	public CreatorID: number = 0;

	@field("string")
	@computed()
	public get Creator(): string {
		let user = DossierService.getUser(this.CreatorID);
		return user.getUserString();
	}

	@field("number")
	public ExtraFieldsID:number = 0;

	@field("has-one", "ProjectExtraFields")
	public ExtraFields:ProjectExtraFields | null = new ProjectExtraFields();

	public AWSDocuments:ProjectAwsDocument[] = [];
	public UnprocessedFiles: File[] = [];
	public toDeleteFiles:ProjectAwsDocument[] = [];

	constructor(data?: any) {
		if (!data) return;

		this.ID = data.ID;
		this.ComputedFriendlyID = data.ComputedFriendlyID || "";
		this.ContactID = data.ContactID;

		this.Description = data.Description;
		this.TimeStamp = new Date(data.TimeStamp);
		this.ExtraFieldsID = data.ExtraFieldsID;

		this.CreatorID = data.CreatorID;

		if (data.Contact) {
			this.Contact = new Contact(data.Contact);
		}

		if (data.ExtraFields){
			this.ExtraFields = new ProjectExtraFields(data.ExtraFields);
		}

		if (data.AWSDocuments) {
			this.AWSDocuments = (data.AWSDocuments as any[]).map(d=>new ProjectAwsDocument(d));
		}

	}


	getJSON() {
		return {
			ID: this.ID,
			ComputedFriendlyID: this.ComputedFriendlyID,
			ContactID: this.ContactID,
			Description: this.Description,
			TimeStamp: this.TimeStamp ? this.TimeStamp.toJSON() : null,
			ExtraFieldsID: this.ExtraFieldsID,
			CreatorID: this.CreatorID,
			Contact: this.Contact,
		};
	}


}